import currentFlightsMapService from "../api/server/currentFlightsMapService";
export const CURRENT_FLIGHTS_MAP_NAMESPACE = "currentFlightsMapModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/currentFlightsMapService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(currentFlightsMapService)
};

const state = {
  flightMarkerData: [],
  flightsDetailData: {},
  airportsDetailData: [],
  detailFlightData: {},
  updatedSinceUtc: null
};
const actions = {
  async LOAD_FLIGHTS(context) {
    var api = await services.api;
    return api.loadFlightMapData().then(function(value) {
      context.commit("SET_FLIGHT_MARKER_DATA", value);
    });
  },
  async LOAD_FLIGHTS_DETAILS(context) {
    var api = await services.api;
    return api
      .loadFlightsDetailData(state.updatedSinceUtc)
      .then(function(value) {
        context.commit("SET_FLIGHTS_DETAILS", value);
      });
  },
  async LOAD_AIRPORTS_DETAILS(context) {
    /* istanbul ignore next */
    if (window.localStorage) {
      var airportData =
        window.localStorage["MGMT_FLIGHTMAP_airportsDetailData"];
      var expiration =
        window.localStorage["MGMT_FLIGHTMAP_airportsDetailData_expiration"];
    }
    var now = new Date(Date.now());
    if (airportData && expiration && expiration > now.getTime()) {
      context.commit("SET_AIRPORTS_DETAILS", airportData);
    } else {
      var api = await services.api;
      return api.loadAirportsDetailData().then(function(value) {
        /* istanbul ignore next */
        if (window.localStorage) {
          window.localStorage["MGMT_FLIGHTMAP_airportsDetailData"] = value;
          var expire = new Date(Date.now());
          expire.setTime(expire.getTime() + 7 * 24 * 60 * 60 * 1000);
          // eslint-disable-next-line
          window.localStorage["MGMT_FLIGHTMAP_airportsDetailData_expiration"] = expire.getTime().toString();
        }
        context.commit("SET_AIRPORTS_DETAILS", value);
      });
    }
  },
  async LOAD_DETAIL_FLIGHT(context, flightId) {
    var api = await services.api;
    return api.loadDetailFlightData(flightId).then(function(value) {
      context.commit("SET_DETAIL_FLIGHT", value);
    });
  }
};
const mutations = {
  SET_FLIGHT_MARKER_DATA(storeState, data) {
    storeState.flightMarkerData = data;
  },
  SET_FLIGHTS_DETAILS(storeState, data) {
    if (data && data.length > 0) {
      var updatedSinceUtcTemp = data[0].tpln;
      data.forEach(d => {
        storeState.flightsDetailData[d.id] = d;
        if (d.tpln > updatedSinceUtcTemp) updatedSinceUtcTemp = d.tpln;
      });
      storeState.updatedSinceUtc = new Date(
        updatedSinceUtcTemp * 1000
      ).toISOString();
      storeState.updatedSinceUtc = storeState.updatedSinceUtc.substring(
        0,
        storeState.updatedSinceUtc.length - 5
      );
    }
  },
  SET_AIRPORTS_DETAILS(storeState, data) {
    var airports = JSON.parse(data);
    storeState.airportsDetailData = {};
    airports.forEach(a => {
      storeState.airportsDetailData[a.id] = a;
      storeState.airportsDetailData[a.id].activeFlights = {
        orig: {},
        dest: {}
      };
    });
  },
  SET_DETAIL_FLIGHT(storeState, data) {
    if (data) storeState.detailFlightData[data.id] = data;
  }
};
const getters = {
  flightMarkerData: storeState => storeState.flightMarkerData,
  flightsDetailData: storeState => storeState.flightsDetailData,
  airportsDetailData: storeState => storeState.airportsDetailData,
  detailFlightData: storeState => storeState.detailFlightData,
  updatedSinceUtc: storeState => storeState.updatedSinceUtc
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
